<template>
  <div class="subscription-landing subscription-landing--waconn">
    <section class="hero">
      <div class="site-width">
        <div class="hero-content">
          <h1 class="clubname">Connoisseurs Club</h1>
          <p class="club-subhead">
            Unparalleled Reds.
            <br />
            Unprecedented Access.
            <br />
            Unrivaled Price.
          </p>
          <p class="description">
            Expand your palate—and your knowledge—with quarterly deliveries of
            stunning, expert-selected wines.
          </p>

          <div class="button-link">
            <p>
              <a v-scroll-to="'#club-choice'" href="#" class="button primary">
                <span class="button-inset">
                  {{ ctaText('Become a Member') }}
                </span>
              </a>
            </p>
            <p>
              <span class="gift-alternative">
                <nuxt-link
                  to="/wine-club/gifting/connoisseurs-club/"
                  class="button"
                >
                  Or gift it
                </nuxt-link>
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="site-width">
        <div class="row xlarge-flex">
          <div
            class="columns large-6 text-center side-image hide-for-medium-down"
          >
            <img
              src="~assets/images/club-conn-glass.jpg"
              class="wineglass"
              alt="Wine Glass"
            />
          </div>
          <div class="columns large-6 text-center large-text-left">
            <p class="max-copy section-heading">
              From Celebrated Vineyards,
              <br />
              To Your Cellar
            </p>
            <p>
              <strong
                >Indulge in established icons, find new favorites, and cultivate
                your collection.</strong
              >
            </p>
            <p>
              You’re an enthusiast with a taste for the rare, the undiscovered,
              the exceptional. You know your way around a wine list, but you’re
              hungry— or thirsty—for more. The Connoisseur Club is for you.
            </p>
            <p>
              Join today and we’ll send you a curated selection by our industry
              experts of two breathtaking bottles, four times a year. From a
              heady mix of celebrated old-world producers and compelling upstart
              vintners, these distinguished wines set industry standards,
              attract cult followings, and grace the menus at Michelin-starred
              restaurants before they reach your doorstep. Along with these
              prized picks, you’ll enjoy unique insights from industry experts,
              early access to limited-supply bottles, and members-only
              discounts. The smoothest path from storied vineyards to your
              cellar— satisfaction guaranteed.
            </p>
            <p>
              <a
                v-if="hasMembershipForClub"
                href="#"
                class="button disabled primary left-large"
                >Currently Enrolled</a
              >
              <a
                v-else
                href="#"
                class="button primary left-large"
                @click.prevent="signup()"
                >{{ ctaText('Become a Member') }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="black wineback1">
      <div class="wineback2">
        <div class="site-width text-center">
          <div>
            <h2 class="benefits">Member Benefits</h2>
            <p>Each wine is hand-selected by a Master Sommelier</p>
          </div>
          <div class="row icon-grid">
            <div class="columns medium-6 large-3">
              <div class="icon">
                <img
                  src="~assets/images/wa-icon-club-discount-white.svg"
                  alt="Percent Symbol"
                  class="icon-desktop"
                />
                <img
                  src="~assets/images/wa-icon-club-discount-white-mobile.svg"
                  alt="Percent Symbol"
                  class="icon-mobile"
                />
              </div>
              <p>10% off all Wine Access purchases *</p>
            </div>
            <div class="columns medium-6 large-3">
              <div class="icon">
                <img
                  src="~assets/images/wa-icon-club-video-white.svg"
                  alt="Video Camera Icon"
                  class="icon-desktop"
                />
                <img
                  src="~assets/images/wa-icon-club-video-white-mobile.svg"
                  alt="Video Camera Icon"
                  class="icon-mobile"
                />
              </div>
              <p>Exclusive video tastings</p>
            </div>
            <div class="columns medium-6 large-3">
              <div class="icon">
                <img
                  src="~assets/images/wa-icon-club-bottle-white.svg"
                  alt="Wine Glass Icon"
                  class="icon-desktop"
                />
                <img
                  src="~assets/images/wa-icon-club-bottle-white-mobile.svg"
                  alt="Wine Glass Icon"
                  class="icon-mobile"
                />
              </div>
              <p>
                Early Access to limited releases and off-the-site selections
              </p>
            </div>
            <div class="columns medium-6 large-3">
              <div class="icon">
                <img
                  src="~assets/images/wa-icon-club-shipping-white.svg"
                  alt="Box Icon"
                  class="icon-desktop"
                />
                <img
                  src="~assets/images/wa-icon-club-shipping-white-mobile.svg"
                  alt="Box Icon"
                  class="icon-mobile"
                />
              </div>
              <p>Complimentary shipping</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="club-choice">
      <div class="site-width text-center">
        <BreadcrumbComponent :breadcrumbs="breadcrumbs" />
        <div>
          <p class="section-heading">
            Impeccable Quality.
            <br />
            Incredible Access.
          </p>
          <p>
            To bring you the highest caliber bottles, we taste over 20,000 wines
            annually—from large, storied estates to excellent boutique vineyards
            across the world. With two unique selections per shipment, the
            Connoisseur Club offers a diverse array of the finest in red wine,
            be it California cab or top-scoring Barolo.
          </p>
        </div>
        <div>
          <div class="bottle-selection red">
            <div class="bottle"></div>
            <div class="bottle"></div>
          </div>
          <div class="club-selector">
            <div class="option">
              <p>All Red</p>
            </div>
          </div>
          <div class="bordered-callout">
            <p>
              2 world-class bottles of red wines, delivered quarterly – $150 per
              shipment
            </p>
          </div>
        </div>
        <p>
          <a
            v-if="hasMembershipForClub"
            href="#"
            class="button disabled primary"
            >Currently Enrolled</a
          >
          <a v-else href="#" class="button primary" @click.prevent="signup()">{{
            ctaText('Become a Member')
          }}</a>
        </p>
      </div>
    </section>
    <ExpertsSection extra-classes="shaded" />
    <section class="pad-zero">
      <div class="club-hands-container">
        <div class="hand-left" />
        <div class="quote-carousel-container">
          <h2>What Our Club Members are Saying</h2>
          <ClientOnly>
            <Carousel v-bind="carouselOptions">
              <Slide v-for="(quote, index) in quotes" :key="index">
                <figure>
                  <blockquote>
                    {{ quote.text }}
                  </blockquote>
                  <figcaption>— {{ quote.source }}</figcaption>
                </figure>
              </Slide>
              <template #addons>
                <Navigation />
                <Pagination />
              </template>
            </Carousel>
          </ClientOnly>
        </div>
        <div class="hand-right" />
      </div>
    </section>
    <section class="shaded text-center">
      <div class="site-width text-center">
        <div>
          <p class="mb-40 section-heading">
            Rare, Delectable—And
            <br />
            Delivered Right to Your Door
          </p>

          <div class="button-link">
            <p>
              <a
                v-if="hasMembershipForClub"
                href="#"
                class="button disabled primary"
              >
                <span class="button-inset">Currently Enrolled</span>
              </a>
              <a
                v-else
                href="#"
                class="button primary"
                @click.prevent="signup()"
              >
                <span class="button-inset">
                  {{ ctaText('Become a Member Today') }}
                </span>
              </a>
            </p>
            <p>
              <span class="gift-alternative">
                <nuxt-link
                  to="/wine-club/gifting/connoisseurs-club/"
                  class="button"
                >
                  {{ hasMembershipForClub ? 'G' : 'Or g' }}ift it
                </nuxt-link>
              </span>
            </p>
          </div>
        </div>
        <div class="content-hero">
          <img
            src="~assets/images/club-conn-footer.jpg"
            alt="2 Wine glasses raised and clinking"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ga4 from '#common/utils/ga4'
import {
  determineDefaultSelectedPlan,
  getClubCrumbs,
  hasMembershipForClub,
  hasMembershipForPlan,
} from '#common/utils/wineclub'
import BreadcrumbComponent from '~/components/Breadcrumb.vue'

export default {
  name: 'ConnoisseursClubIndex',
  components: {
    BreadcrumbComponent,
    ExpertsSection: defineAsyncComponent(
      () => import('@/components/Club/ExpertsSection'),
    ),
  },
  async setup() {
    const { data: clubData, error } = await useFetch('/api/membership/list/')
    if (error.value) {
      console.error('Homepage Data Fetch error:', error.value)
    }
    const club =
      clubData.value.results.find((c) => c.slug === 'connoisseurs-club') || {}
    return {
      club,
      memberships: [],
      selectedPlan: '',
      modalTheme: {
        title: 'Welcome to the Club',
        container: {
          classes: 'wineclub-form',
        },
        login: {
          submitButton: {
            classes: 'primary continue',
          },
        },
        register: {
          submitButton: {
            classes: 'primary continue',
            label: 'Continue',
          },
        },
        emailCheck: {
          submitButton: {
            classes: 'primary continue',
            label: 'Continue',
          },
        },
      },
      carouselOptions: {
        autoplay: 10000,
        pauseAutoplayOnHover: true,
        wrapAround: true,
        itemsToShow: 1,
      },
      quotes: [
        {
          text: 'Love the Connoisseur Club and 2 bottle surprises. The Customer Service exceeds my expectations. When they say “100% guarantee” they really mean it. Had an off bottle and they sent a credit for it.',
          source: 'Jay O.',
        },
        {
          text: 'I have subscribed to several different wine clubs in the past. This is BY FAR the best. The QPR of the wines included in the quarterly box is incredible. I love that you send classic wines, along with some obscure stuff that you don’t see regularly.',
          source: 'Hannah C.',
        },
        {
          text: 'I think Wine Access is the best online wine club. I really like how they “curate” the wine selections and the very knowledgeable staff are a great resource to try new wines.',
          source: 'David K.',
        },
        {
          text: 'Great wine finds with detailed storytelling about producers from all over the world. There’s no wine service/subscription like Wine Access',
          source: 'Robert C.',
        },
        {
          text: 'Overall the experience has been nothing short of phenomenal. They not only provide wine, but each one has an in-depth discussion of the grower, taste profiles, and potential pairings. The shipments become a sought-after source of excitement when the shipment notification hits my email.',
          source: 'Connor H.',
        },
      ],
      breadcrumbs: getClubCrumbs('Connoisseurs Wine Club'),
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    },
    hasMembershipForClub() {
      return hasMembershipForClub(
        'connoisseurs-club-all-reds',
        this.memberships,
      )
    },
  },
  watch: {
    async loggedIn(newValue, oldValue) {
      // Once user data is loaded and we know they're logged in, fetch their memberships
      if (newValue === true && oldValue === false) {
        await this.fetchMemberships()
      }
    },
  },
  mounted() {
    // Default to all red
    this.setPreselectedPlan('connoisseurs-club-all-reds')
    // If they're logged in, fetch their memberships
    if (this.loggedIn) {
      this.fetchMemberships()
    }
    ga4.trackViewClub({ slug: 'connoisseurs-club' })
  },
  methods: {
    async fetchMemberships() {
      const result = await this.$axios.get('/api/membership/')
      this.memberships = result.data.memberships.filter(
        (m) => m.slug === 'connoisseurs-club',
      )
      // If a plan wasn't selected or they have a membership for a plan that was selected previous to login
      if (
        !this.$store.getters.wineClubPreselectedPlan ||
        hasMembershipForPlan(
          this.$store.getters.wineClubPreselectedPlan,
          this.memberships,
        )
      ) {
        // Set the appropriate pre-selected plan based on which clubs they're already a member of
        const defaultPlan = determineDefaultSelectedPlan(this.memberships)
        this.setPreselectedPlan(defaultPlan)
      }
    },
    ctaText(text) {
      if (!this.club || !this.club.plans) return text
      if (
        this.club.plans.some((p) => p.slug === this.selectedPlan && p.is_full)
      ) {
        return 'Join The Waiting List'
      } else {
        return text
      }
    },
    openLoginModal() {
      this.$auth.openAuthModal({
        theme: this.modalTheme,
        redirect: '/connoisseurs-wine-club/join/',
        isClub: true,
      })
    },
    setPreselectedPlan(planSlug) {
      this.selectedPlan = planSlug
      this.$store.dispatch('setWineClubPreselectedPlan', planSlug)
    },
    signup() {
      this.$store.dispatch('setWineClubPreselectedPlan', this.selectedPlan)
      if (!this.$auth.loggedIn) {
        this.openLoginModal()
      } else {
        this.$router.push('/connoisseurs-wine-club/join/')
      }
    },
  },
}
</script>
